import { api } from '@/utils/api';
import type { Kind, RawNotification, PagedResponse } from '@/domain/Notifications/Notifications';
export default class NotificationRepository {
  async getRecentNotifications({
    locationId,
    page,
    size = 500,
    kind = 'ALL',
  }: {
    locationId?: string | number;
    page: number;
    size?: number;
    kind?: Kind;
  }): Promise<PagedResponse<RawNotification> & { totalRecords?: number; currentPage?: number }> {
    const params: Record<string, string | number> = {
      page,
      type: kind,     
    };
    if (typeof size === 'number') params.size = size;
    if (locationId) params.locationId = locationId;

    const { data } = await api.get('/notifications/issues/recent', { params });
    return data;
  }

  async dismissRecentNotifications(issueId: string | number) {
    const { data } = await api.put(`/notifications/issues/${issueId}/dismiss`);
    return data;
  }
}
